// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.src-js-pages-components-pageTitle-pageTitleStyle-module__title--C_nB3 {
  background: #071C35;
}

.src-js-pages-components-pageTitle-pageTitleStyle-module__content--wcfqr {
  padding: 5px 0 5px 5px;
  margin: 5px 0 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/components/pageTitle/pageTitleStyle.module.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["\n.title {\n  background: #071C35;\n}\n\n.content {\n  padding: 5px 0 5px 5px;\n  margin: 5px 0 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `src-js-pages-components-pageTitle-pageTitleStyle-module__title--C_nB3`,
	"content": `src-js-pages-components-pageTitle-pageTitleStyle-module__content--wcfqr`
};
export default ___CSS_LOADER_EXPORT___;
